module.exports = __webpack_public_path__ + "img/tracking-failed.e3063741.png";